module.exports = __webpack_public_path__ + "static/media/home-compact-track-loader.b0d49a29.jpg";